import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconArrowUp = ({ color = 'var(--color-neutral-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.59334 4C5.9566 4 6.13824 3.47929 5.87588 3.1716L3.29263 0.142012C3.13118 -0.0473375 2.86882 -0.0473375 2.70737 0.142012L0.124121 3.1716C-0.138239 3.47929 0.043395 4 0.406664 4L5.59334 4Z"
                fill={color} />
        </svg>
    </div>
);

export default IconArrowUp;
